import { keyframes } from 'styled-components';
import overrideStyle from 'lib/overrideStyle';
import React from 'react';

export default function LoadingPlaceholder(props) {
  return (
    <Wrapper>
      <Dot delay={2} {...props} />
      <Dot delay={1} {...props} />
      <Dot {...props} />
    </Wrapper>
  );
}

LoadingPlaceholder.defaultProps = {
  size: '15px',
};

const Wrapper = overrideStyle('div')`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;
`;

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  } 40% {
    transform: scale(.5);
  }
`;

const Dot = overrideStyle('div')`
  animation: ${bounce} 1.4s infinite ease-in-out both;
  background-color: ${p => {
    return p.color;
  }};
  border-radius: 100%;
  display: inline-block;
  flex-shrink: 0;
  height: ${p => p.size};
  width: ${p => p.size};

  animation-delay: ${p => {
    switch (p.delay) {
      case 1:
        return `${-0.16 * p.delay}s`;
      case 2:
        return `${-0.16 * p.delay}s`;
      case 3:
        return `${-0.16 * p.delay}s`;
      case 4:
        return `${-0.16 * p.delay}s`;
      default:
        return '0s';
    }
  }};
`;
